import {useState} from 'react';
// import {instance} from '../api/axios';
import ContactDetailsForm from './forms/contact-details-form';
import CompanyInfoForm from './forms/company-info-form';
import SubmittedView from './views/submitted-view';
import {FormProvider, useForm} from 'react-hook-form';
import {yupResolver} from "@hookform/resolvers/yup";
import {clientRegistrationSchema} from "../schemas/contact-info.schema";
import {instance} from "../api/axios";
import {message} from "antd";

const Wrapper = () => {
  const [step, setStep] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const methods = useForm({
    mode: 'all',
    resolver: yupResolver(clientRegistrationSchema)
  });
  const handleFinish = () => {
    methods.handleSubmit(onSubmit)()
  };

  const onSubmit = async (formData) => {
    setIsLoading(true);
    try {
      await instance.post('/clients/register', formData);
      setStep(2)
    } catch (e) {
      message.error(e.message)
    } finally {
     setIsLoading(false);
    }
  };

  const renderContent = () => {
    if (step === 1) {
      return (
        <CompanyInfoForm
          onContinue={handleFinish}
          isLoading={isLoading}
        />
      );
    }

    if (step === 2) {
      return <SubmittedView />;
    }

    return (
      <ContactDetailsForm
        onContinue={() => setStep(1)}
      />
    );
  };

  return <FormProvider {...methods}>
    <form>{renderContent()}</form>
  </FormProvider>;
};

export default Wrapper;
